import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import {
  ModalPageBody,
  ModalPageCopy,
  ModalPageFooter,
  ModalPageHeader,
  ModalPageHeading,
  ModalPageWrapper,
} from "../../../organisms/ModalPage";
import "./Pathway.scss";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { loseWeightPageTitle } from "../../../../data/Programme";
import { Pages } from "../../../../data/eligibilityChecker/loseWeight/pages";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";

interface Props {
  progressPercentage?: PowerOfTen;
}

const PathwayEligibleScreen = ({ progressPercentage }: Props) => {
  const dispatch = useDispatch();
  const pathwayPageData = Pages.pathway;
  const history = useHistory();
  const pageTitle = `Supported or digital | ${loseWeightPageTitle} | ${pageTitleSuffix}`;

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
    });
  }, []);

  const handleClick = pathway => {
    dispatch(update_signup_form_values({ pathway }));
    history.push("/introduce-yourself");
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <ModalPageWrapper>
        <ModalPageBody hasStickyFooter={false}>
          <ModalPageHeader
            backButtonOnClick={() => {
              history.goBack();
            }}
          />
          <ModalPageHeading>{pathwayPageData?.questions[0].question}</ModalPageHeading>
          <ModalPageCopy>
            <p>{pathwayPageData?.questions[0].description}</p>
            <p>{pathwayPageData?.questions[0].label}</p>
          </ModalPageCopy>
        </ModalPageBody>
        <ModalPageFooter hasStickyFooter={false}>
          <div className="button-group">
            <Button
              fullwidth
              className="top-button"
              onClick={() => handleClick("Supported")}
              variant="contained"
              color="primary"
            >
              I'd love support
            </Button>
            <Button fullwidth onClick={() => handleClick("Digital")} variant="contained" color="secondary">
              I'll stick with digital
            </Button>
          </div>
        </ModalPageFooter>
      </ModalPageWrapper>
    </>
  );
};

export default PathwayEligibleScreen;
